import DwFormField from '@ui/formfield/DwFormField';
import classNames from 'classnames';
import React, { useMemo } from 'react';
const ProfileNameFields = (props) => {
    const { formdef } = props;
    const isReadOnly = (def) => {
        return (props.readonly == 'novalue' && !!(def === null || def === void 0 ? void 0 : def.htmlValue)) || props.readonly === true;
    };
    const isDisabled = (def) => {
        return (props.disabled == 'novalue' && !!(def === null || def === void 0 ? void 0 : def.htmlValue)) || props.disabled === true;
    };
    const isDrawer = useMemo(() => props.componentContext == 'drawer', [props.componentContext]);
    const titleField = () => (React.createElement(DwFormField, { def: formdef, idSuffix: props.idSuffix, disabled: isDisabled(formdef.title), readonly: isReadOnly(formdef.firstname), name: "title", type: 'select', autocomplete: "honorific-prefix" }));
    const nameField = () => (React.createElement(DwFormField, { def: formdef, idSuffix: props.idSuffix, disabled: isDisabled(formdef.firstname), readonly: isReadOnly(formdef.firstname), name: "firstname", autocomplete: "given-name", validTick: true }));
    const lastField = () => (React.createElement(DwFormField, { def: formdef, idSuffix: props.idSuffix, disabled: isDisabled(formdef.lastname), readonly: isReadOnly(formdef.lastname), name: "lastname", autocomplete: "family-name", validTick: true }));
    const localsureField = () => (React.createElement(DwFormField, { def: formdef, idSuffix: props.idSuffix, disabled: isDisabled(formdef.localsurname), readonly: isReadOnly(formdef.localsurname), name: "localsurname", autocomplete: "family-name", validTick: true }));
    const localnameField = () => (React.createElement(DwFormField, { def: formdef, idSuffix: props.idSuffix, disabled: isDisabled(formdef.localname), readonly: isReadOnly(formdef.localname), name: "localname", autocomplete: "given-name", validTick: true }));
    if (window.country == 'JP') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-lg-12 col-24" }, lastField()),
                React.createElement("div", { className: "col-lg-12 col-24" }, nameField())),
            React.createElement("div", { className: "row align-bottom kr-name-field" },
                React.createElement("div", { className: "col-lg-12 col-24" }, localsureField()),
                React.createElement("div", { className: "col-lg-12 col-24" }, localnameField()))));
    }
    if (window.country == 'HK') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-lg-6 col-xxl-8" }),
                React.createElement("div", { className: "col-lg-18 col-xxl-16" }),
                React.createElement("div", { className: "col-24" })),
            React.createElement("div", { className: "row align-bottom kr-name-field" },
                React.createElement("div", { className: "col-lg-12 col-24" }, localsureField()),
                React.createElement("div", { className: "col-lg-12 col-24" }, localnameField()))));
    }
    if (window.country == 'KR') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: props.isRegisterForm ? 'row' : 'row kr-name-field' },
                React.createElement("div", { className: classNames({
                        'col-lg-6 col-xxl-4 col-8': !isDrawer,
                        'col-6': isDrawer,
                    }) }, titleField()),
                React.createElement("div", { className: classNames({
                        'col-lg-9 col-xxl-10 col-16': !isDrawer,
                        'col-18': isDrawer,
                    }) }, lastField()),
                React.createElement("div", { className: classNames({
                        'col-lg-9 col-xxl-10 col-24': !isDrawer,
                        'col-24': isDrawer,
                    }) }, nameField())),
            React.createElement("div", { className: "row kr-name-field" },
                React.createElement("div", { className: "col-lg-12 col-24" }, localsureField()),
                React.createElement("div", { className: "col-lg-12 col-24" }, localnameField()))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `row ${props.gap ? `row-gap-${props.gap}` : ''}` },
            React.createElement("div", { className: props.componentContext == 'modal' || props.componentContext == 'drawer' ? 'col-24' : 'col-lg-6 col-xxl-8' }, titleField()),
            React.createElement("div", { className: props.componentContext == 'modal' || props.componentContext == 'drawer' ? 'col-24' : 'col-lg-18 col-xxl-16' }, nameField())),
        React.createElement("div", { className: `row ${props.gap ? `mt-${props.gap}` : ''}` },
            React.createElement("div", { className: "col-24" }, lastField()))));
};
export default ProfileNameFields;
